module.exports = __webpack_public_path__ + "b3349631e071e5e983d1b21c02318c0f.svg";


//////////////////
// WEBPACK FOOTER
// ./images/un-group-icon-v-2.svg
// module id = 71
// module chunks = 0